export class OffersService {
  constructor(axios, apiUrl) {
    this.$axios = axios;
    this.apiUrl = apiUrl;
  }

  /**
   * Get a discount by id
   * @returns Discount
   */
  async getLatestOffer(id, sessionId) {
    return await this.$axios.get(this.apiUrl + `Offers/customer/${id}/Offer/Latest?onlyReturnServiceOffers=false`,
      {
        headers: {
          'X-SessionId': sessionId
        }
      }
    ).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });
  }

  /**
   * 
   * @returns Premium Package Details
   * 
   */
  async getPremiumPackageOffer(custNo, sqldbid, id) {

    return await this.$axios.get(this.apiUrl + `Offers/Customer/${custNo}/Company/${sqldbid}/Package/${id}`
    ).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });
  }

  async getPremiumPackageInfo(persistedState) {
    try {
      const upPackage = persistedState?.branchInfo?.UPPackage;
      const IMCYear = persistedState?.branchInfo?.IMCYear;
      const premiumPackageInfo = [];

      if (upPackage) {
        const filteredPremiumData = upPackage.filter(
          (item) => item.Year === IMCYear
        );

        // Create concurrent promises for all valid items
        const offerPromises = filteredPremiumData
          .filter(item => item?.PNameID) // Only process items with valid PNameID
          .map(async (item) => {
            const PNameID = item.PNameID;

            try {
              const offer = await this.getPremiumPackageOffer(
                persistedState.scope.cust_No,
                persistedState.scope.sqldbid,
                PNameID,
                persistedState.scope.id
              );

              offer["PNameID"] = PNameID;
              return offer;
            } catch (error) {
              console.error(`Failed to get premium package offer for PNameID ${PNameID}:`, error);
              return null; // Return null for failed requests
            }
          });

        // Wait for all promises to resolve concurrently
        const offers = await Promise.all(offerPromises);
        
        // Filter out any null results from failed requests and add to array
        premiumPackageInfo.push(...offers.filter(offer => offer !== null));

        return premiumPackageInfo;
      }

      return undefined;
    } catch (err) {
      console.error(err);
      return undefined;
    }
  }

}
